import {Component, OnInit} from '@angular/core';
import {DefaultComponent} from '../default/default.component';

@Component({
    selector: 'app-adult-language',
    templateUrl: './adultLanguage.component.html'
})
export class AdultLanguageComponent extends DefaultComponent implements OnInit {
    protected product = 'al';
}
